export default "__VITE_ASSET__v4RYa9UI__"